import Types from "./Types";

const INITIAL_STATE = {
  liveVideos: { items: [] },
  selectedLiveVideo: null,
  isLoading: false,
  count: "",
};

export default function superadminLiveVideos(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_SUPERADMIN_LIVE_VIDEOS_SUCCESS: {
      return {
        ...state,
        liveVideos: { items: payload.data },
        count: payload.data.length,
      };
    }

    case Types.GET_SUPERADMIN_LIVE_VIDEO_BY_ID_SUCCESS: {
      return {
        ...state,
        selectedLiveVideo: payload.data,
      };
    }

    case Types.CREATE_SUPERADMIN_LIVE_VIDEO_SUCCESS: {
      const data = payload.data.data;
      let newArray = [...state.liveVideos.items, data];
      return {
        ...state,
        liveVideos: { ...state.liveVideos, items: newArray },
        count: state.count + 1,
      };
    }

    case Types.UPDATE_SUPERADMIN_LIVE_VIDEO_SUCCESS: {
      let data = payload.data;
      const liveVideos = state.liveVideos.items;
      let idx = 0;
      liveVideos.forEach((video, index) => {
        if (video.id === data.id) {
          idx = index;
          return;
        }
      });

      liveVideos[idx] = data;
      return {
        ...state,
        liveVideos: { ...state.liveVideos, items: liveVideos },
      };
    }

    case Types.DELETE_SUPERADMIN_LIVE_VIDEO_SUCCESS: {
      const liveVideos = state.liveVideos.items;
      const newLiveVideos = liveVideos.filter((video) => video.id !== payload);
      return {
        ...state,
        liveVideos: { ...state.liveVideos, items: newLiveVideos },
      };
    }

    case Types.GET_SUPERADMIN_LIVE_VIDEOS_BY_COURSE_SUCCESS: {
      return {
        ...state,
        liveVideos: { items: payload.data },
        count: payload.data.length,
      };
    }

    case Types.GET_SUPERADMIN_LIVE_VIDEOS_BY_TEACHER_SUCCESS: {
      return {
        ...state,
        liveVideos: { items: payload.data },
        count: payload.data.length,
      };
    }

    case Types.SUPERADMIN_LIVE_VIDEOS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    default: {
      return state;
    }
  }
} 